import { PageContainer } from "@/ui/containers/PageContainer";
import * as z from "zod";
import { voucherSchema } from "../schemas/voucherSchema";
import { VoucherForm } from "../components/VoucherForm";
import { useCreateVoucher } from "@/shared/core-vouchers";
import { useLocation, useNavigate } from "react-router-dom";
import { trackEvent } from "@/utils/firebase/analytics";
import { notify } from "@/ui/chakra/notify";

export const CreateVoucherPage = () => {
  const { createVoucher } = useCreateVoucher();
  const navigate = useNavigate();
  const location = useLocation();

  const selectedVoucher = location.state?.voucher || null;

  const onSubmit = async (data: z.infer<typeof voucherSchema>) => {
    await createVoucher(
      {
        voucherDate: data.voucherDate,
        voucherTypeId: data.voucherType.value,
        activityLabelId: data.activityLabel.value,
        workOrderId: data.workOrder?.value,
        equipmentInstanceId: data.equipmentInstance?.value,
        zoneId: data.zone,
        storageId: data.storage.value,
        productApplicantId: data.productApplicant.value,
        costCenterId: data.costCenter.value,
        clientEntityId: data.clientEntity.value,
        comment: data.comment,
        products: data.products,
      },
      {
        onSuccess: () => {
          trackEvent("voucher_created", {
            source: selectedVoucher ? "copy" : "new",
          });
          notify.success("Vale creado");
        },
        onError: (error) => notify.error("Error al crear el vale", error),
      },
    );
  };

  return (
    <PageContainer
      title="Crear vale"
      breadcrumb={[
        { label: "Operaciones" },
        { label: "Vales", href: "/vouchers" },
        { label: "Nuevo" },
      ]}
      pb={0}
      display="flex"
      flexDirection="column"
    >
      <VoucherForm
        onSubmit={onSubmit}
        selectedVoucher={selectedVoucher}
        variant="page"
        confirmBeforeSubmit
        onCancel={() => navigate("/vouchers")}
      />
    </PageContainer>
  );
};
